import PropTypes from 'prop-types';
import {
  BooleanInput,
  Edit,
  email,
  Identifier,
  ReferenceInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  usePermissions,
  useTranslate,
} from 'react-admin';

const SubscriptionEditToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
const SubscriptionEditEmbedded = ({ id }: { id?: Identifier }) => {
  const { permissions } = usePermissions();
  const translate = useTranslate();
  return (
    <Edit title=" " id={id}>
      <SimpleForm toolbar={<SubscriptionEditToolbar />}>
        <TextInput
          source="first_name"
          validate={required()}
          disabled={permissions != 'master'}
          label={translate('resources.subscriptions.fields.first_name')}
        />

        <TextInput source="last_name" validate={required()} disabled={permissions != 'master'} />
        <TextInput source="email" validate={[required(), email()]} disabled={permissions != 'master'} />
        {permissions === 'editor' && <TextInput source="password" />}
        {permissions === 'master' && (
          <ReferenceInput source="role" reference="role">
            <SelectInput optionText="name" validate={[required()]} />
          </ReferenceInput>
        )}
        {permissions === 'master' && <BooleanInput label="Disabled" source="deleted" />}
      </SimpleForm>
    </Edit>
  );
};

SubscriptionEditEmbedded.propTypes = {
  record: PropTypes.object,
  resource: PropTypes.string,
  id: PropTypes.string,
};

export default SubscriptionEditEmbedded;
